
<div class="row form-group" style="margin-top:2px">
  <label class="control-label col-2">Ngày học<span class="cred">(*)</span></label>
  <div class="col-2">
    <kendo-dateinput tabindex="1" style="width:138px !important;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayHoc"></kendo-dateinput>
  </div>
  <!--<label class="control-label col-1">C nhánh</label>
  <div class="col-3">
    <ng-select #slChiNhanh
               class="twcollong"
               [tabIndex]="4"
               [openOnEnter]="false"
               [items]="dschinhanhs"
               [disabled]="true"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="25"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               (change)="changeChiNhanh($event)"
               [(ngModel)]="doituongSelect.DonViId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>-->
  <label class="control-label col-1">Ca học</label>
  <div class="col-3">
    <ng-select #slCaHoc
               class="twcollong"
               [tabIndex]="4"
               [openOnEnter]="false"
               [items]="dscahocs"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="25"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               (change)="changeLichHoc($event)"
               [(ngModel)]="doituongSelect.LichHocId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <label class="control-label col-1">Lớp</label>
  <div class="col-3">
    <ng-select #slLop
               class="twcollong"
               [tabIndex]="3"
               [disabled]="true"
               [openOnEnter]="false"
               [items]="dslops"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="26"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               [(ngModel)]="doituongSelect.LopId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>

<div class="row form-group">

  <label class="control-label col-2 ng-binding">Dạy chính<span class="cred">(*)</span></label>
  <div class="col-4">
    <ng-select #slGiaoVienChinh
               class="twcollong"
               [tabIndex]="19"
               [openOnEnter]="false"
               [items]="inputGiangViens"
               bindValue="Id"
               bindLabel="Ten"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn"
               [(ngModel)]="doituongSelect.DayChinhId">
      <ng-template ng-option-tmp let-item="item">

        <div class="rTableRow">
          <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
          <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <label class="control-label col-2 ng-binding">Trợ giảng 1</label>
  <div class="col-4">
    <ng-select #slGiaoVienChinh
               class="twcollong"
               [tabIndex]="19"
               [openOnEnter]="false"
               [items]="inputGiangViens"
               bindValue="Id"
               bindLabel="Ten"
               placeholder="Trợ giảng 1"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn"
               [(ngModel)]="doituongSelect.TroGiang1Id">
      <ng-template ng-option-tmp let-item="item">

        <div class="rTableRow">
          <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
          <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>

<div class="row form-group">

  <label class="control-label col-2 ng-binding">Trợ giảng 2</label>
  <div class="col-4">
    <ng-select #slGiaoVienChinh
               class="twcollong"
               [tabIndex]="19"
               [openOnEnter]="false"
               [items]="inputGiangViens"
               bindValue="Id"
               bindLabel="Ten"
               placeholder="Trợ giảng 2"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn"
               [(ngModel)]="doituongSelect.TroGiang2Id">
      <ng-template ng-option-tmp let-item="item">

        <div class="rTableRow">
          <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
          <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <label class="control-label col-2 ng-binding">Người hỗ trợ</label>
  <div class="col-4">
    <ng-select #slGiaoVienChinh
               class="twcollong"
               [tabIndex]="19"
               [openOnEnter]="false"
               [items]="inputGiangViens"
               bindValue="Id"
               bindLabel="Ten"
               placeholder="Trợ giảng 3"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn"
               [(ngModel)]="doituongSelect.TroGiang3Id">
      <ng-template ng-option-tmp let-item="item">

        <div class="rTableRow">
          <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
          <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  
</div>

<div class="row form-group">
  <label class="control-label col-2 ng-binding">Người tạo</label>
  <div class="col-4">
    <input type="text" tabIndex="8" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
  </div>
  <label class="control-label col-2 ng-binding">Thời lượng</label>
  <div class="col-4">
    <input class="form-control"
           maxlength="20"
           tabindex="4"
           currencyMask
           [(ngModel)]="doituongSelect.ThoiLuong"
           name="value"
           [placeholder]="''"
           [options]="ngxCurrencyOptions" autocomplete="off" />
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-2 ng-binding">Ghi chú</label>
  <div class="col-10">
    <textarea type="text" tabIndex="7" rows="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
  </div>
</div>

<div class="row form-group">
  <label class="control-label col-2" style="font-weight:bold">Danh sách học viên</label>
  <div class="col-10">
    <div class="full-right" style="float:right">
      <button class="btn btn-info btn-add" (click)="ChonHocVien()">{{'Thêm học viên' | translate}}</button>
      <div style="margin-top:3px">
        <input type="checkbox" style="width:23px;height:23px;padding-right:5px;margin-left:5px;margin-top:2px" [(ngModel)]="TatCa" (click)="TichTatCa()" />
      </div>
      <label class="control-label">Chọn tất cả</label>
    </div>
    
  </div>
</div>


<!-- lưới chi tiết -->
<div style="padding: 2px 10px 10px 10px;color:black !important; height: calc(100vh - 320px)">
  <div class="row">
    <table class="table table-striped table-bordered table-hover table-condensed">
      <thead [ngClass]="{'theadcss': totalItems>16}">
        <!--<thead>-->
        <tr>
          <th style="width:40px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Trạng thái</th>
          <th style="min-width:130px;text-align:center;background-color:#f3f8fc">Tên học viên</th>
          <th style="min-width:100px;text-align:center;background-color:#f3f8fc">Bí danh</th>
          <th style="min-width:130px;text-align:center;background-color:#f3f8fc">Tên phụ huynh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Số điện thoại</th>
          <th style="min-width:110px;text-align:center;background-color:#f3f8fc">Điểm danh</th>
          <th style="min-width:150px;text-align:center;background-color:#f3f8fc">Lý do vắng mặt</th>
          <th style="min-width:110px;text-align:left;background-color:#f3f8fc">Tính buổi?</th>
          <th *ngIf="CachTinhHocPhi==5" style="min-width:110px;text-align:left;background-color:#f3f8fc">Đã thu học phí</th>
          <th *ngIf="CachTinhHocPhi==5" style="min-width:110px;text-align:left;background-color:#f3f8fc">Số tiền</th>
          <th style="min-width:110px;text-align:left;background-color:#f3f8fc">
            <!--Khóa học ĐK-->
          </th>


        </tr>

        <tr class="filter-row">
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td style="text-align:center"></td>
          <td *ngIf="CachTinhHocPhi==5" style="text-align:center"></td>
          <td *ngIf="CachTinhHocPhi==5" style="text-align:center"></td>
          <td style="text-align:center"></td>


        </tr>

      </thead>
      <tbody style="height:calc(100vh - 360px);">
        <tr *ngFor="let u of doituongSelect.ChiTiets; let i = index" [ngClass]="{'backgroud_color_diemdanh': u.DangKyGoiHocId === null}">
          <td style="width:40px;text-align:center"><a>{{u.STT}}</a></td>
          <td style="min-width:120px">
            <div class="x-grid-cell-inner" style="text-align: center;">
              <a *ngIf="u.TT==1" style="background-color: #00a651!important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==2" style="background-color: orange !important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==0" style="background-color: red !important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>

            </div>
          </td>
          <td style="min-width:130px"><a>{{u.HoVaTen}}</a></td>
          <td style="min-width:100px"><a>{{u.TenGoiKhac}}</a></td>
          <td style="min-width:130px"><a>{{u.TenPhuHuynh}}</a></td>
          <td style="min-width:120px;font-weight:bold"><a>{{u.DienThoaiDiDong}}</a></td>
          <td style="text-align:center;min-width:150px">
            <input type="checkbox"
                   [(ngModel)]="u.DiemDanh"
                   (ngModelChange)="onDiemDanhChange(u)" />
          </td>
          <td style="min-width:150px">
            <input type="text" [(ngModel)]="u.GhiChu" style="width:100%" />
          </td>
          <td style="text-align:center;min-width:110px">
            <input type="checkbox" [(ngModel)]="u.TinhBuoi" style="margin-right:10px" />
          </td>
          <td *ngIf="CachTinhHocPhi==5" style="text-align:center;min-width:110px">
            <input type="checkbox" [(ngModel)]="u.DaTinhHocPhi" style="margin-right:10px" />
          </td>
          <td *ngIf="CachTinhHocPhi==5" style="text-align:right;min-width:110px">
            <input class="form-control"
                   maxlength="20"
                   tabindex="5"
                   currencyMask
                   [(ngModel)]="u.ThucThu"
                   name="value"
                   [placeholder]="''"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </td>
          <td style="min-width:110px">
            <a title="Xóa dòng" (click)="deleterow(i)" style="margin-left:5px;cursor:pointer;color:#1e6bb8 !important" class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted">Xóa dòng</a>
            <!--<a *ngIf="u.DangKyGoiHocId!==null" (click)="ChonDangKyGoiHoc(i,u.NhanSuId)">{{u.KhoaHoc}}</a>
    <a *ngIf="u.DangKyGoiHocId==null" (click)="ChonDangKyGoiHoc(i,u.NhanSuId)">Chọn...</a>-->
          </td>

        </tr>
      </tbody>
    </table>


  </div>

</div>







<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div>
    <span style="color:red">Tổng số học viên: {{tong_hv}} (Đi học: {{tong_dihoc}} - Nghỉ học: {{tong_nghihoc}})</span>
  </div>
  <div class="">
    <button type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">{{'Ghi lại' | translate}}</button>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
  </div>

</div>


<bs-modal #mdChonHocVien class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChonHocVien.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chonhocvienedit #chonhocvienedit (save)="saveModal($event)"></app-tonghop-chonhocvienedit>
  </bs-modal-body>
</bs-modal>



<bs-modal #mdChonDangKyGoiHoc class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">Chọn đăng ký gói học</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChonDangKyGoiHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-tonghop-chondangkygoihocedit #chondangkygoihocedit (save)="saveModal_DangKyGoiHoc($event)"></app-tonghop-chondangkygoihocedit>
  </bs-modal-body>
</bs-modal>

